import { render, staticRenderFns } from "./MessageContext.vue?vue&type=template&id=5c9e4b15"
import script from "./MessageContext.vue?vue&type=script&lang=js"
export * from "./MessageContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports